import {
  WORK_TYPE_MESSAGE_IDS,
  WorktypeAnalysisRating,
} from '@/features/types';
import { useClientTerminology } from '@/views/list/NetworkTerms';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import classes from './WorktypeLegend.module.css';
import legendClasses from '@/views/map/MapLayerManager/MapLayerLegend.module.css';

const RATINGS: { rating: WorktypeAnalysisRating; className: string }[] = [
  {
    rating: WorktypeAnalysisRating.Side_Wall,
    className: classes.indicatorSideWall,
  },
  {
    rating: WorktypeAnalysisRating.Cut_Zone,
    className: classes.indicatorCutZone,
  },
  {
    rating: WorktypeAnalysisRating.Mow_Zone,
    className: classes.indicatorMowZone,
  },
  {
    rating: WorktypeAnalysisRating.Herbicide_Zone,
    className: classes.indicatorHerbicideZone,
  },
  {
    rating: WorktypeAnalysisRating.Not_Vegetation,
    className: classes.indicatorNotVegetation,
  },
];

export const WorktypeLegend = () => {
  const isSmallScreen = useSmallScreen();
  const intl = useClientTerminology();
  return (
    <div data-testid="worktype-legend">
      {!isSmallScreen && (
        <div className={legendClasses.legendTitle} id="worktype-toggle">
          {intl.formatMessage({ id: 'map.layerManager.worktypeAnalysisTitle' })}
        </div>
      )}
      <div className={`${legendClasses.legend} ${classes.layout}`}>
        {RATINGS.map(({ rating, className }, index) => (
          <span key={index}>
            <span
              className={`${classes.indicator} ${className}`}
              data-testid="worktype-indicator"
            />
            {intl.formatMessage({ id: WORK_TYPE_MESSAGE_IDS[rating] })}
          </span>
        ))}
      </div>
    </div>
  );
};
